export const DEFAULT_PAGE_SIZE_OPTIONS: number[] = [5, 10, 25, 100];
export const DEFAULT_PAGE_SIZE: number = DEFAULT_PAGE_SIZE_OPTIONS[0];
